export default "https://cdn-static.gokick.com/assets/62cc856e78696df0fd8dcc0a94c6851d482ca838/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";